import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { USER_TYPES } from '../../../../Admin/shared/static-options';
import { LOCAL_STORAGE_USER_TYPE } from '../../../../../shared/http/auth';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import { ALLOWANCE, allowanceEnumTransKey } from '../enums';

import { Container } from '../styles';

const label = Object.values(ALLOWANCE);

const Allowance = ({ isOpen, onClick, onApply, allowance }) => {
  const [selectedItem, setSelectedItem] = useState(allowance);

  useEffect(() => {
    if(allowance?.length < 1) {
      setSelectedItem([]);
    }
  }, [allowance]);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  const userType = window.localStorage.getItem(LOCAL_STORAGE_USER_TYPE);

  return USER_TYPES.CUSTOMER_SERVICE_USER === Number(userType) ? (
    <NFFilter label="Abono" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por abono"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <Container>
          {label.map((filter, idx) => (
            <CheckboxControl
              key={Number(idx)}
              value={filter}
              onChange={handleChange}
              defaultChecked={selectedItem.some(
                item => parseInt(item) === filter,
              )}
              label={allowanceEnumTransKey[filter]}
            />
          ))}
        </Container>
      </FilterForm>
    </NFFilter>
  ) : null;
};

const mapStateToProps = state => ({
  allowance: state.tracking.filters.listAllowance,
});

export default connect(mapStateToProps)(Allowance);
